import { useQuery } from "@tanstack/react-query";
import request from "../../../Api/Api.js";

export function useBlogPosts() {
  return useQuery({
    queryKey: ["blogPosts"],
    queryFn: () => request.get("/blog-posts").then((response) => response.data),
  });
}
